import { useEffect, useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";


const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export const writingEffect = async (fullSentence, time, setFullSentence, setFinished) => {

    let newWorld = ''

    for(let char of fullSentence){
        await sleep(time);
        newWorld+=char
        setFullSentence(newWorld)
    }

    setFinished(true)

}

const Console = () => {

    const inputRef = useRef(null);

    const [introText, setIntroText] = useState('')
    const [introFinished, setIntroFinished] = useState(false)
    const [texto, setTexto] = useState("")
    const [result, setResult] = useState(undefined)
    const [fullResult, setFullResult] = useState(undefined)
    const [fullResultFinished, setFullResultFinished] = useState(false)

    const comandos = [
        {
        nodes : [
            {
                type : "branch",
                value: "Olá",
                nodes: [
                    {
                        type: "branch",
                        value: "queria dizer que",
                        nodes : [
                            {
                                type: "leaf",
                                value: "nossas comunicações falharam",
                                result: "Skill issue"
                            },
                            {
                                type: "node",
                                value: "não consigo mais",
                                nodes : [
                                    {
                                        type: "leaf",
                                        value: "prosseguir com a comunicação",
                                        result: "[COMMRESET]"
                                    },
                                    {
                                        type: "leaf",
                                        value: "agradar a ele",
                                        result: "fuja..."
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        type: "branch",
                        value : "sua presença é",
                        nodes : [
                            {
                                type: "leaf",
                                value: "ilustre",
                                result: "igualmente"
                            },
                            {
                                type: "leaf",
                                value: "um problema",
                                result: ":("
                            }
                        ]
                    }
                ]
            },
            {
                type: "branch",
                value: "Entrando em contato para",
                nodes : [
                    {
                        type: "branch",
                        value: "pedir que",
                        nodes : [
                            {
                                type: "leaf",
                                value: "a comunicação passe a diante",
                                result: "[FAILEDCOMM]"
                            },
                            {
                                type : "leaf",
                                value : "a comunicação seja encerrada",
                                result: "[COMMFINISHED]"
                            },
                            {
                                type : "leaf",
                                value : "Um bolo seja feito",
                                result: `Preparando bolo de ameixas...
                                    Adicionando cobertura de chocolate...
                                    Adicionando cereja...
                                    FALHA CRITICA: CEREJAS FORA DE ESTOQUE
                                    NULLCEREJAEXCEPTION
                                    CRITICAL_ERROR`
                            }
                        ]
                    },
                    {
                        type : "branch",
                        value : "informar que",
                        nodes : [
                            {
                                type : "leaf",
                                value : "perdemos contato",
                                result: "Que pena..."
                            },
                            {
                                type : "leaf",
                                value : "a comunicação foi um sucesso",
                                result: "..."
                            }
                        ]
                    }
                ]
            }
        ]
    }
    ]

    const [currentBranch, setCurrentBranch] = useState(comandos[0]);
    const [selectedCommand, setSelectedCommand] = useState(0);
    const [branchesValues, setBranchesValues] = useState([]);

    const handleSelect = (action) => {

        if(currentBranch === undefined) return;

        const isInBoundaries = 
            action > 0 ? (
                selectedCommand + action < currentBranch.nodes.length 
            ) : action < 0 ? (
                selectedCommand + action >= 0
            ) : false;
        
        if (!isInBoundaries) return;

        setSelectedCommand(selectedCommand + action);
    }

    const handleEnter = () => {

        if(currentBranch === undefined) return;

        if(currentBranch.nodes[selectedCommand].type === "leaf"){
            setCurrentBranch(undefined)
            let oldBranchesValues = branchesValues;
            oldBranchesValues.push(currentBranch.nodes[selectedCommand].value)
            setResult(currentBranch.nodes[selectedCommand].result)
            setBranchesValues(oldBranchesValues)
            return
        }
        else{
            setCurrentBranch(currentBranch.nodes[selectedCommand])
        }

        let oldBranchesValues = branchesValues;
        oldBranchesValues.push(currentBranch.nodes[selectedCommand].value)
        setBranchesValues(oldBranchesValues)
    }

    const findParent = (root, targetValue) => {
        if (!root.nodes) return null;
        
        if (root.nodes.map(n => n.value).includes(targetValue)) {
            return root;
        }

        for (let node of root.nodes) {
            const parent = findParent(node, targetValue);
            if (parent) {
                return parent;
            }
        }

        return null;
    }

    const handleBackspace =() => {

        let targetValue = currentBranch ?
            currentBranch.value
            : branchesValues[branchesValues.length-1];

        if(!targetValue) return;

        if (currentBranch === comandos[0]) return;

        const parent = findParent(comandos[0], targetValue);

        if (parent) {
            setCurrentBranch(parent);
            setSelectedCommand(0);
            
            // Remove o último valor adicionado visualmente
            let newBranchesValues = [...branchesValues];
            newBranchesValues.pop();
            setBranchesValues(newBranchesValues);
        }
    }

    useEffect(() => {
        console.log(texto)
    }, [texto])

    useEffect(() => {

        writingEffect(
            `
            Bzzz...
            Chhhh...
            Beep!
            Bip!
            Bzzt
            Conexão direta >`,
            5, 
            setIntroText,
            setIntroFinished
        )

    }, [])

    useEffect(() => {
        writingEffect(
            `
                MESSAGE_SENT
                WAITING_FOR_REPLY
                \t${result}
                END_OF_COMMUNICATION
            `,
            30,
            setFullResult,
            setFullResultFinished
        )
    }, [result])

    return (

        <div className="console-page-background" onClick={() => inputRef.current && inputRef.current.focus()}>
            <div className="console-content-container">
                {introText.split("\n").map((linha, index) => {
                    return (
                        <>
                            {linha}
                            {index < introText.split("\n").length - 1 ?
                                <>
                                    <br/>
                                    <br/>
                                </>
                                : <></>
                            }
                        </>
                    )
                })}
                {
                    introFinished &&
                    <>
                        <input 
                            ref={inputRef}
                            type="text" 
                            className="console-input"
                            value={branchesValues.map(b => " " + b).join("")}
                            onChange={(e) => {
                                setTexto(e.target.value)
                            }}
                            style={{
                                width: (branchesValues.length > 0 ? branchesValues.reduce((acc, c) => acc + c.length, 0) : 0)+20+"ch"
                            }}
                            autoFocus={true}
                            onKeyDown={(e) => {
                                if(e.key === "ArrowLeft"){
                                    handleSelect(-1);
                                }
                                else if(e.key === "ArrowRight"){
                                    handleSelect(1)
                                }
                                else if(e.key === "Enter"){
                                    handleEnter()
                                }
                                else if(e.key === "Backspace"){
                                    handleBackspace()
                                }
                            }}
                        />
                    </>
                }
                {
                    introFinished && (currentBranch ? (
                            <div className="commands-select-container">
                                {
                                    currentBranch.nodes.map((node, index) => 
                                        <div className={index === selectedCommand ? "selected-command" : ""}>
                                            {node.value}
                                        </div>
                                    )
                                }
                            </div>
                        ) : !fullResultFinished ? 
                            <div className={"selected-command"}>
                                Enviar
                            </div>
                            :
                            <div className={"selected-command-result"}>
                                {fullResult.split("\n").map((linha, index) => (
                                    <>
                                        {linha}
                                        {index < fullResult.split("\n").length - 1 ?
                                            <>
                                                <br/>
                                                <br/>
                                            </>
                                            : <></>
                                        }
                                    </>
                                ))}
                            </div>
                    )
                }
            </div>
        </div>

    )
}

export default Console;